import GoogleLogo from 'src/images/pngs/brands/google.png';
import ComptiaLogo from 'src/images/pngs/brands/comptia.png';
import CyberCommandPolandLogo from 'src/images/pngs/brands/cyber_command_poland.png';
import KpmgLogo from 'src/images/pngs/brands/kpmg.png';
import RsmLogo from 'src/images/pngs/brands/rsm.png';
import EduScotlandLogo from 'src/images/pngs/brands/edu-scotland.png';
import EpitechLogo from 'src/images/pngs/brands/epitech.png';
import { Brand } from './brands.types';
export const brandsList: Brand[] = [{
  name: 'GoogleLogo',
  image: GoogleLogo
}, {
  name: 'ComptiaLogo',
  image: ComptiaLogo
}, {
  name: 'EducationScotlandFoghlamAlbaLogo',
  image: EduScotlandLogo
}, {
  name: 'EpitechTechnologyLogo',
  image: EpitechLogo
}, {
  name: 'KpmgLogo',
  image: KpmgLogo
}, {
  name: 'CyberCommandPolandLogo',
  image: CyberCommandPolandLogo
}, {
  name: 'RsmLogo',
  image: RsmLogo
}];